import React from 'react';
import DateTimePicker from '@lib/components/DateTimePicker/DateTimePicker';
import { InputTypes } from '@lib/components/Input/enums';
import { ComponentProps, defaultProps } from '../types';

export default function DatetimePreview({ t }: ComponentProps) {
  return (
    <DateTimePicker
      {...defaultProps}
      label={t('select-date-and-time')}
      type={InputTypes.time}
    />
  );
}
